import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {HeaderService} from "../../services/header/header.service";
import {MainService} from "../../services/main/main.service";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.sass']
})
export class AccountComponent implements OnInit {
  activeIndex: number = 0;
  companyBin: any;
  stateModeration: any;
  loaded: boolean = false;

  constructor(private route: Router, public headerService: HeaderService, private main: MainService) {}

  ngOnInit() {
    this.selectActiveTab();
    if (this.headerService.currentCompany) {
      this.companyBin = this.headerService.currentCompany;
      this.getCompanyData();
    }
    if(this.headerService.userData && !this.headerService.userData.companyList?.length) {
      this.loaded = true;
    }

    this.headerService.companyChangeEmitter.subscribe(company => {
      this.companyBin = this.headerService.currentCompany;
      this.getCompanyData();
    });

    this.headerService.changeUserDataEmitter.subscribe((userData)=> {
      if(!userData.companyList?.length) {
        this.loaded = true;
      }
    })
  }

  getCompanyData() {
    this.main.getCompanyInfo(this.companyBin).subscribe({
      next: (res: any) => {
        this.stateModeration = res.state.id
        this.selectActiveTab();
      },complete: () => {
        this.loaded = true;
      }
    });
  }

  changeRoute(event: any) {
    if((!this.stateModeration || this.stateModeration < 1) && event.index == 4) {
      event.index++
    }
    switch (event.index) {
      case 0:
        this.route.navigate(['account/tu-orders']);
        break;
      case 1:
        this.route.navigate(['account/sales']);
        break;
      case 2:
        this.route.navigate(['account/purchases']);
        break;
      case 3:
        this.route.navigate(['account/my-products-and-services']);
        break;
      case 4:
        this.route.navigate(['account/edit-company']);
        break;
      case 5:
        this.route.navigate(['account/yandex']);
        break;
    }
  }

  selectActiveTab() {
    switch (this.route.url) {
      case 'account/tu-orders':
        this.activeIndex = 0;
        break;
      case '/account/sales':
        this.activeIndex = 1;
        break;
      case '/account/purchases':
        this.activeIndex = 2;
        break;
      case '/account/my-products-and-services':
        this.activeIndex = 3;
        break;
      case '/account/edit-company':
        this.activeIndex = 4;
        break;
      case '/account/yandex':
        if(!this.stateModeration || this.stateModeration < 1) {
          this.activeIndex = 4;
        } else {
          this.activeIndex = 5;
        }
        break;
    }
  }
}
